export const SERIES_PLAY_EPISODE_EVENT = 'pg:playEpisode'
export const SERIES_EPISODE_ENDED_EVENT = 'pg:seriesEpisodeEnded'
export const SERIES_TOGGLE_EPISODE_EVENT = 'pg:toggleEpisode'
export const SERIES_EPISODE_PLAY_STATE_EVENT = 'pg:episodePlayState'

export interface SeriesEpisodeEndedDetail {
  seriesId?: string | null
  episodeId: string
}

export interface SeriesEpisodePlayStateDetail {
  episodeId: string | null
  isPlaying: boolean
}